<template>
  <span
    class="text-muted"
    v-text="text"
  />
</template>

<script>

/**
 * Текст о том, что данные пустые.
 */
export default {
  name: 'NoData',
  props: {
    /**
     * Текс для вывода.
     */
    text: {
      type: String,
      default: 'Нет данных'
    }
  }
}
</script>
